import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

export const initImgColorParams = { imgKey: '', colors: 6, brightAdjust: 0, saturationAdjust: 0 };

const initialState = {
  imgcolor: { data: null, loading: false },
  params: { ...initImgColorParams },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
